<template>
  <v-container>
    <v-row>
      <v-col class="grey--text text-h2" cols="12">
        <p>Listar Cadastros</p>
      </v-col>
      <v-col cols="12">
        <CPTSelect
          class="pt-6"
          v-model="processoSelected"
          :items="processos"
          item-text="nome"
          return-object
          required
          label="Processo Anual"
          @input="onSelectItem('processo')"
        />
      </v-col>
      <v-card outlined>
        <v-row class="pa-4">
          <v-col cols="12" md="4">
            <CPTInput
              v-model="protocolo"
              v-maska="'############'"
              label="Protocolo"
              counter="12"
            />
          </v-col>
          <v-col cols="12" md="4">
            <CPTInput
              v-model="matricula"
              v-maska="'###########'"
              label="Matrícula"
              counter="11"
            />
          </v-col>
          <v-col cols="12" md="4">
            <CPTInput v-model="aluno" label="Aluno" />
          </v-col>

          <v-col cols="12" md="4">
            <CPTSelect
              v-model="etapa"
              :items="etapas"
              item-text="nome"
              label="Etapa"
              return-object
            />
          </v-col>

          <v-col cols="12" md="4">
            <CPTSelect
              v-model="status"
              :items="tipoStatus"
              item-text="label"
              label="Status"
              return-object
            />
          </v-col>

          <v-col cols="12" md="4">
            <CPTAutocomplete
              v-model="unidadeEnsino"
              :items="unidadesEnsino"
              clearable
              item-text="nomeCompleto"
              label="Unidade de Origem"
              return-object
            />
          </v-col>
          <v-col cols="12" md="4">
            <CPTAutocomplete
              v-model="unidadeDestino"
              :items="unidadesDestino"
              clearable
              item-text="nomeCompleto"
              label="Unidade de Destino"
              return-object
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="mt-0">
              <v-switch
                v-model="particularidades"
                class="ml-2"
                label="Deficiência"
              ></v-switch>

              <v-switch
                v-model="vulnerabilidadeSocial"
                class="ml-2"
                label="Vulnerabilidade Social"
              ></v-switch>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="d-flex justify-end">
          <CPTBtn
            label="Limpar Filtros"
            icon="mdi-filter-remove"
            class-btn="mr-1"
            :loading="loading"
            @click="onSelectItem('filtro')"
          />
          <CPTBtn
            label="Buscar"
            icon="mdi-magnify"
            :loading="loading"
            @click="getDataFromApi()"
          />
        </v-card-actions>
      </v-card>
      <v-col cols="12">
        <v-data-table
          :footer-props="footerProps"
          :headers="headers"
          :items="inscricoesFiltradas"
          :options.sync="options"
          :server-items-length="totalItems"
          disable-sort
        >
          <template v-slot:item="{ item: inscricao }">
            <tr
              class="cvi-table-row"
              :key="inscricao.id"
              @click="onClickInscricao(inscricao)"
            >
              <td>
                {{ inscricao.protocolo }}
              </td>

              <td>
                {{ inscricao.matricula.codigo }}
              </td>

              <td>
                <span class="d-inline-block text-truncate">
                  {{ inscricao.matricula.etapa.nome }}
                </span>
              </td>

              <td>
                {{ inscricao.matricula.unidadeEnsino.nomeCompleto }}
              </td>

              <td>
                <span v-if="inscricao.unidadeDestino">{{
                  inscricao.unidadeDestino.nomeCompleto
                }}</span>
              </td>

              <td>
                {{ inscricao.matricula.pessoa.nome }}
              </td>

              <td>
                <span class="d-inline-block text-truncate">
                  {{
                    format(
                      parseISO(inscricao.matricula.pessoa.data_nascimento),
                      "dd/MM/yyyy"
                    )
                  }}
                </span>
              </td>

              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ma-0 d-flex justify-center"
                      v-bind="attrs"
                      v-on="on"
                      :color="
                        inscricao.particularidades
                          ? 'green lighten-3'
                          : 'red lighten-3'
                      "
                      >{{
                        inscricao.particularidades
                          ? "mdi-thumb-up"
                          : "mdi-thumb-down"
                      }}</v-icon
                    >
                  </template>
                  <span>{{ inscricao.particularidades ? "SIM" : "NÃO" }}</span>
                </v-tooltip>
              </td>

              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ma-0 d-flex justify-center"
                      v-bind="attrs"
                      v-on="on"
                      :color="
                        inscricao.vulnerabilidade_social
                          ? 'green lighten-3'
                          : 'red lighten-3'
                      "
                      >{{
                        inscricao.vulnerabilidade_social
                          ? "mdi-thumb-up"
                          : "mdi-thumb-down"
                      }}</v-icon
                    >
                  </template>
                  <span>{{
                    inscricao.vulnerabilidade_social ? "SIM" : "NÃO"
                  }}</span>
                </v-tooltip>
              </td>

              <td class="d-flex align-center justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-text="getStatusConfig(inscricao.status).icon"
                      :color="getStatusConfig(inscricao.status).color"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <span>{{ getStatusConfig(inscricao.status).label }}</span>
                </v-tooltip>
              </td>

              <td
                v-if="isAdmin()"
                @click="showDialogExclusao(inscricao), $event.stopPropagation()"
              >
                <span class="d-flex align-center justify-center">
                  <v-icon
                    color="red"
                    @click="
                      showDialogExclusao(inscricao), $event.stopPropagation()
                    "
                  >
                    mdi-delete
                  </v-icon>
                </span>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-alert border="right" colored-border type="error" elevation="2">
              Nenhuma inscrição encontrada.
            </v-alert>
          </template>
        </v-data-table>
      </v-col>

      <v-col v-if="loading" cols="12">
        <v-skeleton-loader type="list-item@15" />
      </v-col>

      <DialogInscricao
        v-if="dialog"
        v-model="inscricaoVisualizando"
        :unidadesEnsino="unidadesEnsino"
        @save="($event) => onSaveInscricao($event)"
        @close="dialog = false"
      />

      <v-dialog v-if="inscricaoExcluir" v-model="dialogExclusao" width="750">
        <v-card>
          <v-card-title class="primary text-h6 white--text">
            Excluir inscrição? Esta ação não poderá ser desfeita.
          </v-card-title>

          <v-card-text class="py-3">
            <v-row>
              <v-col cols="12">
                Protocolo: {{ inscricaoExcluir.protocolo }}
              </v-col>
              <v-col cols="12">
                Aluno:
                {{ inscricaoExcluir.matricula.pessoa.nome }}
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />

          <v-card-actions class="d-flex justify-end">
            <CPTBtn
              label="Não"
              @click="(inscricaoExcluir = null), (dialogExclusao = false)"
            />
            <CPTBtn label="Sim" @click="excluirInscricao(inscricaoExcluir)" />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="dialogConfirma" v-model="dialogConfirma" width="750">
        <v-card>
          <v-card-title class="primary text-h6 white--text">
            Tem certeza que deseja ordenar as inscrições?
          </v-card-title>

          <v-card-text class="py-3">
            <v-row>
              <v-col cols="12">
                Esta ação não podera ser desfeita!
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />
          <v-card-actions class="d-flex justify-end">
            <CPTBtn label="Não" @click="dialogConfirma = false" />
            <CPTBtn label="Sim" @click="ordenarInscricoes()" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import CPTAutocomplete from "@/components/Autocomplete";
import CPTBtn from "@/components/Btn";
import CPTInput from "@/components/Input";
import DialogInscricao from "@/pages/PLANTAO_DE_FERIAS/consulta-plantao/components/DialogCadastro.vue";
import CPTSelect from "@/components/Select";
import { last } from "lodash";
import { format, parseISO } from "date-fns";
import { isAdmin } from "@/plugins/security";

const tipoStatus = [
  { label: "DEFERIDO", value: "DEFERIDO" },
  { label: "PENDENTE", value: "PENDENTE" },
  { label: "ELIMINADO", value: "ELIMINADO" },
  { label: "AGUARDANDO CORREÇÃO", value: "AGUARDANDO_CORRECAO" },
];

export default {
  name: "lista-cadastros",

  components: {
    CPTAutocomplete,
    CPTBtn,
    CPTInput,
    DialogInscricao,
    CPTSelect,
  },

  data: () => ({
    aluno: "",
    atualizandoInscricoes: false,
    cadastro: true,
    dialog: false,
    dialogConfirma: false,
    dialogExclusao: true,
    etapa: null,
    etapas: null,
    inscricaoExcluir: null,
    inscricaoVisualizando: null,
    inscricoes: [],
    inscricoesFiltradas: [],
    matricula: "",
    particularidades: false,
    processoJudicial: false,
    processoSelected: null,
    processos: [],
    protocolo: "",
    loading: false,
    status: null,
    tablePage: 1,
    tipoStatus,
    unidadeEnsino: null,
    unidadesEnsino: [],
    unidadeDestino: null,
    unidadesDestino: [],
    vulnerabilidadeSocial: false,
    totalPages: 0,
    currentPage: 0,
    totalItems: 0,
    options: {},
  }),

  computed: {
    footerProps() {
      return this.inscricoes.length
        ? {
            "items-per-page-options": [10, 25, 50, 100],
            "items-per-page-text": "Inscrições por página",
          }
        : {
            "disable-items-per-page": true,
            "disable-pagination": true,
            "items-per-page-text": "Inscrições por página",
          };
    },
    headers() {
      const defaultHeaders = [
        {
          text: "Protocolo",
          value: "protocolo",
          filter: (protocolo) =>
            !this.protocolo || protocolo.includes(this.protocolo),
        },
        {
          text: "Matrícula",
          value: "matricula.codigo",
          filter: (matricula) =>
            !this.matricula || matricula.includes(this.matricula),
        },
        {
          text: "Etapa",
          value: "matricula.etapa.id",
          filter: (id) => !this.etapa || id == this.etapa.id,
        },
        {
          text: "Unidade Origem",
          value: "matricula.unidadeEnsino.id",
          filter: (id) => !this.unidadeEnsino || id == this.unidadeEnsino.id,
        },
        {
          text: "Unidade Destino",
          value: "unidadeDestino.id",
          filter: (id) => !this.unidadeDestino || id == this.unidadeDestino.id,
        },
        {
          text: "Aluno",
          value: "matricula.pessoa.nome",
          filter: (aluno) => !this.aluno || aluno.includes(this.aluno),
        },
        {
          text: "Nascimento",
          value: "matricula.pessoa.data_nascimento",
        },
        {
          text: "Deficiência",
          value: "particularidades",
          filter: (particularidades) =>
            !this.particularidades || particularidades,
        },
        {
          text: "Vulnerabilidade Social",
          value: "vulnerabilidade_social",
          filter: (vulnerabilidade_social) =>
            !this.vulnerabilidade_social || vulnerabilidade_social,
        },
        {
          text: "Status",
          value: "status",
          filter: (status) => !this.status || status == this.status.value,
        },
      ];

      const headers = this.inscricoes.length
        ? this.isAdmin()
          ? [...defaultHeaders, { text: "Cancelar" }]
          : defaultHeaders
        : [];

      return headers;
    },
  },

  mounted() {
    this.getUnidadesEnsino();
    this.getEtapas();
    this.getProcessos();
  },

  methods: {
    isAdmin,
    format,
    parseISO,

    excluirInscricao({ id }) {
      this.loading = true;
      this.$http
        .delete(`plantao-ferias/${id}`)
        .then(({ message }) => {
          this.inscricoes = this.inscricoes.filter(
            (inscricao) => inscricao.id !== id
          );
          this.inscricoesFiltradas = this.inscricoesFiltradas.filter(
            (inscricao) => inscricao.id !== id
          );

          this.dialogExclusao = false;
          this.inscricaoExcluir = false;
          this.loading = false;

          this.showMessage(message, "success");
        })
        .catch((error) => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    },

    onSaveInscricao(inscricaoUpdated) {
      let indexInscricao = this.inscricoes.findIndex(
        (i) => i.id == inscricaoUpdated.id
      );
      Object.assign(this.inscricoes[indexInscricao], inscricaoUpdated);
      indexInscricao = this.inscricoesFiltradas.findIndex(
        (i) => i.id == inscricaoUpdated.id
      );
      Object.assign(this.inscricoesFiltradas[indexInscricao], inscricaoUpdated);
      this.dialog = false;
    },

    onSelectItem(item) {
      this.protocolo = null;
      this.matricula = null;
      this.aluno = null;
      this.etapa = null;
      this.status = null;
      this.unidadeEnsino = null;
      this.unidadeDestino = null;
      this.vulnerabilidadeSocial = false;
      this.processoJudicial = false;
      this.particularidades = false;
      item == "processo"
        ? this.getInscricoes()
        : (this.inscricoesFiltradas = this.inscricoes);
    },

    async getUnidadesEnsino() {
      this.unidadesEnsino = this.unidadesDestino = await this.$erudio
        .get("unidades-ensino")
        .catch((error) => this.showMessage(error, "error"));
    },

    async getEtapas() {
      this.etapas = await this.$erudio
        .get("etapas", {
          params: {
            curso: 11,
          },
        })
        .catch((error) => this.showMessage(error, "error"));
    },

    async getProcessos() {
      await this.$http
        .get("processo-plantao")
        .then((processos) => {
          this.processos = processos;
          this.processoSelected = last(processos);
        })
        .catch((error) => this.showMessage(error, "error"));
    },

    async getInscricoes() {
      if (!this.processoSelected) await this.getProcessos();
      this.cadastro = true;

      const queryParams = `
        page=${this.options.page}&
        size=${this.options.itemsPerPage}&
        protocolo=${this.protocolo}&
        matricula=${this.matricula}&
        unidadeOrigemId=${this.unidadeEnsino?.id}&
        unidadeDestinoId=${this.unidadeDestino?.id}&
        particularidades=${this.particularidades || null}&
        vulnerabilidadeSocial=${this.vulnerabilidadeSocial || null}&
        status=${this.status?.value}&
        etapaId=${this.etapa?.id}&
        aluno=${this.aluno}
      `;

      return await this.$http.get(
        `plantao-ferias/processo/${
          this.processoSelected.id
        }?${queryParams.trim()}`
      );
    },

    getStatusConfig(status) {
      switch (status) {
        case "DEFERIDO":
          return { color: "green", icon: "mdi-check", label: "Deferido" };
        case "ELIMINADO":
          return { color: "red", icon: "mdi-close", label: "Eliminado" };
        case "PENDENTE":
          return {
            icon: "mdi-minus",
            label: "Pendente",
          };
        case "AGUARDANDO_CORRECAO":
          return {
            color: "orange",
            icon: "mdi-alarm",
            label: "Aguardando Correção",
          };
        default:
          return { color: "blue", icon: "mdi-help", label: "N/A" };
      }
    },

    onClickInscricao(inscricao) {
      this.inscricaoOriginal = {
        ...inscricao,
      };

      this.inscricaoVisualizando = {
        ...inscricao,
        editing: false,
      };

      this.dialog = true;
    },

    showDialogExclusao(inscricao) {
      this.inscricaoExcluir = inscricao;
      this.dialogExclusao = true;
    },

    async getDataFromApi() {
      this.loading = true;

      this.getInscricoes().then((data) => {
        this.inscricoes = data.inscricoes;
        this.totalItems = data.totalItems;
        this.loading = false;
        this.inscricoesFiltradas = data.inscricoes;
      });
    },
  },

  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
};
</script>

<style>
.cvi-table-row {
  cursor: pointer;
}
</style>
